// Single source of truth for env lookups across the FE.
//
// The app supports two parallel env mechanisms (both are needed):
//   1. `public/env.js` populates `window.env` at runtime. In production the
//      deploy workflow generates this file from AWS Parameter Store and uploads
//      it to S3 next to the build, so one build artefact can serve any
//      environment and a config change needs no rebuild. The copy committed in
//      `public/` is an empty placeholder.
//   2. `.env` at the FE root is read by Create React App at build time and
//      compiled into `process.env.REACT_APP_*` — used by `npm start` / local
//      dev. CRA's webpack DefinePlugin replaces each LITERAL reference like
//      `process.env.REACT_APP_FOO` with the string from `.env` at compile
//      time. Dynamic access (`process.env[key]`) is NOT replaced, and the
//      `process` global itself is not polyfilled in the browser — so we
//      must enumerate every key with a literal access below.

const BUILD_ENV = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_META_APP_ID: process.env.REACT_APP_META_APP_ID,
  REACT_APP_FB_APP_ID: process.env.REACT_APP_FB_APP_ID,
  REACT_APP_WA_CONFIG_ID: process.env.REACT_APP_WA_CONFIG_ID,
  REACT_APP_WA_REDIRECT_URI: process.env.REACT_APP_WA_REDIRECT_URI,
  REACT_APP_TRANSIT_ENC_KEY: process.env.REACT_APP_TRANSIT_ENC_KEY,
  // Which surface this bundle serves. Set per-bucket via window.env in prod;
  // src/constants/appIdentity.js falls back to the hostname when unset.
  REACT_APP_APP_ID: process.env.REACT_APP_APP_ID,
  // Per-surface origins, so a cross-domain link works on staging too.
  REACT_APP_ORIGIN_WEB_APP: process.env.REACT_APP_ORIGIN_WEB_APP,
  REACT_APP_ORIGIN_WEB_INTERIOR: process.env.REACT_APP_ORIGIN_WEB_INTERIOR,
  REACT_APP_ORIGIN_WEB_ARCH: process.env.REACT_APP_ORIGIN_WEB_ARCH,
  // '.buildvizer.com' in production to share one session across the three
  // domains; empty everywhere else, which keeps cookies host-only.
  REACT_APP_COOKIE_DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN,
};

const clean = (v) => (typeof v === "string" ? v.trim() : "");

// Read `window.env` first (runtime overrides win), fall back to the
// build-time map. Empty / whitespace strings are treated as missing so the
// fallback fires when `public/env.js` ships with `KEY: ""`.
export const env = (key) => {
  const fromWindow = clean(typeof window !== "undefined" ? window?.env?.[key] : undefined);
  if (fromWindow) return fromWindow;
  return clean(BUILD_ENV[key]) || "";
};
